export const iconFontAwesomeAnimalsDragon = (
	<i className="fa-solid fa-dragon"></i>
);
